import { ReactElement } from "react";
import { Button, ModalV2 } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import styles from "../styles_vanilla.css";
import { ModalHeader } from "./styles_vanilla.css";

interface ExportSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ExportSuccessModal = ({
  isOpen,
  onClose,
}: ExportSuccessModalProps): ReactElement => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <ModalV2
      show={isOpen}
      onHide={onClose}
      size="small"
      headerClassName={ModalHeader}
      headerIconProps={{
        type: "download",
        size: "xxx-large",
        color: Colors.Neutral600,
      }}
      title="Export in progress"
      description="Once the report is ready, you will receive an email with a link to download the
            report"
    >
      <ModalV2.Footer className={styles.completeModalFooter}>
        <Button onClick={handleOnClose} isFullWidth>
          Okay, got it
        </Button>
      </ModalV2.Footer>
    </ModalV2>
  );
};
